<template>
  <v-app>
    <template v-if="!isAppLoading">
      <snack-bar />

      <v-snackbar
        v-model="snackWithButtons"
        color="success"
        class="center"
        :timeout="timeout"
        top
        right
      >
        {{ snackWithBtnText }}
        <v-spacer />
        <v-btn
          class="primary"
          @click.native="refreshApp"
        >
          {{ snackBtnText }}
        </v-btn>
        <v-btn
          icon
          @click="snackWithButtons = false"
        >
          <v-icon>close</v-icon>
        </v-btn>
      </v-snackbar>

      <auth-app v-if="isLoggedIn && !(isPublic || isPlatform)" />
      <public-app v-if="isPublic" />
      <platform-app v-if="isPlatform" />
    </template>
    <v-content v-else>
      <v-layout
        align-center
        justify-center
        row
        fill-height
      >
        <v-progress-circular
          :size="125"
          :width="10"
          color="primary"
          indeterminate
        />
      </v-layout>
    </v-content>
  </v-app>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import SnackBar from '@/components/SnackBar.vue'
import PublicApp from "./components/Apps/PublicApp"
import PlatformApp from "./components/Apps/PlatformApp"
import AuthApp from "./components/Apps/AuthApp"

export default {
  components: {
    AuthApp,
    PlatformApp,
    PublicApp,
    SnackBar,
  },
  data() {
    return {
      refreshing: false,
      registration: null,
      snackBtnText: '',
      snackWithBtnText: '',
      snackWithButtons: false,
      timeout: 0
    }
  },
  computed: {
    ...mapGetters([ 'isAppLoading', 'isLoggedIn']),
    isPublic() {
      return this.$route.matched.some(record => record.meta.isPublic)
    },
    isPlatform() {
      const isPlatform = this.$route.matched.some(record => record.meta.isPlatform)
      // this.$vuetify.theme.dark = !!isPlatform //!isPublic
      return isPlatform
    }
  },
  watch: {
    '$route': function() {
      // const isPlatform = this.$route.matched.some(record => record.meta.isPlatform)
      /**
       * TEMPORARY - Overriding the theme to be the company theme
       */
      //this.$vuetify.theme.dark = true //! isPublic
    }
  },
  created() {
    this.initPlatformConfig()

    document.addEventListener('swUpdated', this.showRefreshUI)

    navigator.serviceWorker.addEventListener(
      'controllerchange', () => {
        if (this.refreshing) return
        this.refreshing = true
        window.location.replace(window.location.origin)
      }
    )
  },
  methods: {
    ...mapActions([ 'setIsPublic', 'initPlatformConfig', 'initTenantConfigs' ]),
    showRefreshUI(event) {

      //console.log('event fired', event)
      this.registration = event.detail
      this.snackBtnText = 'Refresh'
      this.snackWithBtnText = "New version available!"
      this.snackWithButtons = true
    },
    refreshApp() {
      this.snackWithButtons = false

      // protects against missing reg.waiting
      if (!this.registration || !this.registration.waiting) {
        return
      }

      this.registration.waiting.postMessage('skipWaiting')
    },
  }
}
</script>
